import React from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "@/aible";
import * as viewReducer from "containers/View/reducer";
import styles from "./style.module.css";
import PinnedIconNew from "images/Sense-Icons/pinned.svg";
import UnpinnedIcon from "images/Sense-Icons/unpinned.svg";
import PinnedHoverIcon from "images/Sense-Icons/unpin.svg";
const AgentPinButton = ({ agentId }) => {
    const dispatch = useDispatch();
    const isAgentPinned = useSelector((state) => viewReducer.getIsAgentPinned(state, agentId));
    return (React.createElement("div", { className: styles.pinnedButton },
        React.createElement(Button, { onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                dispatch(viewReducer.updateIsAgentPinned(agentId, !isAgentPinned));
            }, style: { padding: "4px" }, active: isAgentPinned, className: styles.pinButton },
            React.createElement("img", { className: styles.pinNoHover, src: isAgentPinned ? PinnedIconNew : UnpinnedIcon }),
            React.createElement("img", { className: styles.pinHover, src: isAgentPinned ? PinnedHoverIcon : UnpinnedIcon }))));
};
export default AgentPinButton;
